export default __webpack_public_path__ + "static/media/Initiate's Belt of the Celestial Hilt.f62829c3.jpg";